'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
const isWebView = () => typeof MobileWebKit !== 'undefined';
const isWebkit2 = () => {
  var _MobileWebKit, _MobileWebKit2;
  return isWebView() && typeof ((_MobileWebKit = MobileWebKit) === null || _MobileWebKit === void 0 ? void 0 : _MobileWebKit.executeNative) === 'function' && typeof MobileWebKit.events !== 'undefined' && typeof MobileWebKit.events.subscribeMethod === 'function' && typeof MobileWebKit.events.unsubscribe === 'function' && MobileWebKit.engine === ((_MobileWebKit2 = MobileWebKit) === null || _MobileWebKit2 === void 0 || (_MobileWebKit2 = _MobileWebKit2.Engines) === null || _MobileWebKit2 === void 0 ? void 0 : _MobileWebKit2.V200);
};
exports.isWebView = isWebView;
exports.isWebkit2 = isWebkit2;
